import React from 'react';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import * as path from '../../util/pathConstructor';
import { getQueryParameters, getParentPageDomain } from '../../util/utils';

import { receiveInlineStatus, fetchPageMeta, receiveParentDomain } from '../../actions/inlineActions';

import AssessmentApp from './assessmentApp/assessmentApp';
import PollApp from './pollApp/pollApp';
import Footer from '../footer/footer';

import './application.scss';

const DEFAULT_APP_PARAM = 'diets';
const DEFAULT_APP_PROMPT_ID = '1';

const mapStateToProps = (state) => {
    return {
        inlineInfo: state.inline.info,
        inlineConfig: state.inline.config,
        parentMetadata: state.inline.parentMetadata
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        receiveInlineStatus: (status) => dispatch(receiveInlineStatus(status)),
        receiveParentDomain: (domain) => dispatch(receiveParentDomain(domain)),
        fetchPageMeta: (url, domain) => dispatch(fetchPageMeta(url, domain)),
    }
};

class App extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const currentInlineStatus = this.getInlineStatus();
        this.handleInline(currentInlineStatus);
    }

    componentDidUpdate(prevProps) {
        const currentInlineStatus = this.getInlineStatus();

        if (prevProps.inlineInfo.status !== currentInlineStatus) {
            this.handleInline(currentInlineStatus);
        }

        if (prevProps.inlineInfo.parentDomain !== this.props.inlineInfo.parentDomain) {
            this.getParentMetadata();
        }
    }

    handleInline(status) {
        this.props.receiveInlineStatus(status);

        const parentDomain = getParentPageDomain();
        this.props.receiveParentDomain(parentDomain);
    }

    getInlineStatus() {
        const status = +getQueryParameters(this.props.location.search).in === 1 ? true : false;
        return status;
    }

    getParentMetadata() {
        //if already populated, don't fetch again
        if (Object.keys(this.props.parentMetadata).length === 0) {
            const parentPath = getQueryParameters(this.props.location.search).subid2;

            if (parentPath) {
                this.props.fetchPageMeta(parentPath, this.props.inlineInfo.parentDomain);
            }
        }
    }

    getRedirectPath() {
        const { location } = this.props;
        
        return path.getPromptPath(DEFAULT_APP_PARAM, location.search, DEFAULT_APP_PROMPT_ID);
    }

    render() {
        const redirectPath = this.getRedirectPath();

        const {
            inlineInfo,
            inlineConfig
        } = this.props;

        return (
            <>
                <Switch>
                    {/* Redirect original Diet Finder route */}
                    <Route path={`/assessment/prompt`} render={() => <Redirect to={redirectPath} />} />

                    <Route path={`/assessment/:assessmentName`} component={AssessmentApp} />
                    <Route path={`/poll/:pollId`} component={PollApp} />
                </Switch>

                {inlineInfo.status && inlineConfig.hideFooter ? null : <Footer className='bottom' />}
            </>
        )
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));